// Reliability Score Constants
export const RELIABILITY = {
  INITIAL_SCORE: 3.0,
  MIN_SCORE: 0.0,
  MAX_SCORE: 5.0,
  COMPLETION_BONUS: 0.15,
  NO_SHOW_PENALTY: -0.50,
  LATE_CANCELLATION_PENALTY: -0.30, // < 2 hours before
  EARLY_CANCELLATION_PENALTY: -0.05, // > 24 hours before
  STREAK_BONUS: 0.25, // Every 5 consecutive completions
  STREAK_THRESHOLD: 5,
} as const;

// Score tiers for UI display
export const SCORE_TIERS = [
  { min: 4.5, max: 5.0, label: 'Elite', color: '#FFD700', emoji: '🏆' },
  { min: 4.0, max: 4.49, label: 'Excellent', color: '#4CAF50', emoji: '⭐' },
  { min: 3.5, max: 3.99, label: 'Great', color: '#2196F3', emoji: '👍' },
  { min: 3.0, max: 3.49, label: 'Good', color: '#9E9E9E', emoji: '👌' },
  { min: 2.0, max: 2.99, label: 'Fair', color: '#FF9800', emoji: '⚠️' },
  { min: 0.0, max: 1.99, label: 'At Risk', color: '#F44336', emoji: '🚨' },
] as const;

// Campus configuration
export const CAMPUSES = {
  uci: {
    name: 'University of California, Irvine',
    slug: 'uci',
    email_domain: 'uci.edu',
    geofence_lat: 33.6405,
    geofence_lng: -117.8443,
    geofence_radius_km: 5,
  },
} as const;

// Study categories
export const STUDY_CATEGORIES = [
  'Psychology',
  'Neuroscience',
  'Computer Science',
  'Biology',
  'Economics',
  'Sociology',
  'Education',
  'Health Sciences',
  'Engineering',
  'Business',
  'Other',
] as const;

// Common majors at UCI
export const UCI_MAJORS = [
  'Biological Sciences',
  'Business Administration',
  'Computer Science',
  'Cognitive Sciences',
  'Criminology, Law and Society',
  'Economics',
  'Education Sciences',
  'Engineering (Biomedical)',
  'Engineering (Civil)',
  'Engineering (Computer)',
  'Engineering (Electrical)',
  'Engineering (Mechanical)',
  'English',
  'Film and Media Studies',
  'History',
  'Informatics',
  'International Studies',
  'Mathematics',
  'Nursing',
  'Pharmaceutical Sciences',
  'Philosophy',
  'Physics',
  'Political Science',
  'Psychology',
  'Public Health',
  'Social Ecology',
  'Sociology',
  'Software Engineering',
  'Spanish',
  'Other',
] as const;

export const ETHNICITIES = [
  'Asian',
  'Black or African American',
  'Hispanic or Latino',
  'Native American or Alaska Native',
  'Native Hawaiian or Pacific Islander',
  'White',
  'Two or More Races',
  'Prefer not to say',
  'Other',
] as const;

// JWT config
export const JWT = {
  ACCESS_TOKEN_EXPIRY: '1h',
  REFRESH_TOKEN_EXPIRY_DAYS: 30,
  ISSUER: 'apex-research',
} as const;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PER_PAGE: 20,
  MAX_PER_PAGE: 100,
} as const;
